// src/transform/filter.ts
function filter(data, options) {
  const { callback } = options;
  if (callback) {
    data.dataArray = data.dataArray.filter(callback);
  }
  return data;
}
export {
  filter
};
